import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const glAccountModURL = "api/v1/account-app/glaccount";

//obtaining the paginated data
export const getGLAccount = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${glAccountModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};
//obtaining all fiscal sessions
export const getAllGLAccount = () => axiosInstance.get(`${glAccountModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageGLAccount = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${glAccountModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createGLAccount = (body) => axiosInstance.post(`${glAccountModURL}/create`, body);

//updating function
export const updateGLAccount = (id, body) => axiosInstance.patch(`${glAccountModURL}/update/${id}`, body);

// get by id

export const getGLAccountById = (id) => axiosInstance.get(`${glAccountModURL}/retrieve/${id}`);
//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${glAccountModURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);

// checking the redundant data
export const checkRedundantDataGLAccountName = (e, cancelToken) =>
  axiosInstance.get(`${glAccountModURL}name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
export const checkRedundantDataGLAccountCode = (e, cancelToken) =>
  axiosInstance.get(`${glAccountModURL}code=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
